import React from 'react';
export const Header = () => {
  return <header className="bg-[#3885B2] text-white py-2" data-id="element-352">
      <div className="container mx-auto px-4" data-id="element-353">
        <div className="flex justify-between items-center" data-id="element-354">
          <div data-id="element-355">
            <h1 className="text-lg font-bold" data-id="element-356">ProVitalność</h1>
          </div>
          <div data-id="element-357">
            <span className="text-sm" data-id="element-358">Wsparcie dla kobiet w menopauzie</span>
          </div>
        </div>
      </div>
    </header>;
};